import React from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './css/custom.css';
import './css/ExpandTable.css';
import xml2js from "xml2js";
import BootstrapTable from 'react-bootstrap-table-next';
import {
    NavItem, NavLink, Nav, TabContent, TabPane, Input, UncontrolledAlert,
    Row, Col, Card, Button, Form, Spinner, FormGroup, Label
} from 'reactstrap';
import FormularioMateriaVice from './FormularioMateriaVice';
import { withRouter } from "react-router";
import FormularioActVice from './FormularioActVice';
import classnames from 'classnames';
import Modal from 'react-bootstrap/Modal';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { color, color_head_desc_act, color_head_desc_mat, toPostRequest } from './functions/ExpandTableFunctions';
import { AppContext } from '../AppContext';
import { BsEye } from 'react-icons/bs';
import Sticky from 'react-stickynode';
import url from './variables/url.js';
const local = url.localBack;

function importAll(r) {
  let images = {};
  r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
  return images
}

const images = importAll(require.context('./icons', false, /\.(png|jpe?g|svg)$/));

const MySwal = withReactContent(Swal)
const colorStatus = { "A": "#2dc937", "R": "#cc3232", "P": "#e7b416" }
const rankHours = { "TC": { min: "1880", max: "1960", label: "TIEMPO COMPLETO" }, "MT": { min: "940", max: "980", label: "MEDIO TIEMPO" }, "TP": { min: "892", max: "932", label: "TIEMPO PARCIAL" } }

//const fechaInicio = process.env.REACT_APP_FECHA_INICIO_VICE;
//const fechaFin = process.env.REACT_APP_FECHA_FIN_VICE;

// const products = [{ "id": 0, "name": "alola", "price": "2" }, { "id": 1, "name": "alola2", "price": "3" },
// { "id": 2, "name": "alola3", "price": "4" }];
const currentDate = new Date();
/*const bandera = currentDate > new Date(fechaInicio) && currentDate < new Date(fechaFin);*/

class ExpandTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        expanded: [], fila: [], next: false, validaciones: [], delegados: [], revisados: [], idautoridad: '0',
        idProf: this.props.match.params.id ?? 0, nombreProf: '', idUnidad: 0,
        dataForm: [], dataUATH: [], show: false, showDelegar: false, showReasignar: false, idValid: '0', observacion: '',
        horasTotal: 0,
        horasLicencia: 0,
        atendidoVice: "N",
        idUser: 0,
        infoDelegado: false,
        idCoordinador: '0', idPrograma: '0', coordinadores: [], activeTab: "1", nombreCoordinador: '', roles: [],
        tipoContrato: "", sticky: false, status: 0, checkContrato: false,
        enviado: false,
        enviadoVRA: false,
        otrasHoras: 0,
        rejectEstado: [{ cod: 'N', nombre: '' }, { cod: 'L', nombre: 'Loading....' }],
        rechazarState: 'N',
        delegarEstado: [{ cod: 'N', nombre: '' }, { cod: 'L', nombre: 'Loading....' }],
        delegarState: 'N',
        decanoRespuestas: [],
        viceRespuestas: [],
        hayComentarios: false,
        devuelto: false,
        operando: false,
        operando2: false,
        alertas: [],
        bandera: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleChangeModal = this.handleChangeModal.bind(this);
    this.handleCoordinadorChange = this.handleCoordinadorChange.bind(this);
    this.handleChangeObservacionesVice = this.handleChangeObservacionesVice.bind(this);

      if (window.location.pathname.includes('/profesorVicerrector/')) {
          this.populateTable();
      }

    fetch(local + 'Validacion/GetDataForm', {
      method: 'GET'
    }).then(response => response.json())
      .then(data => {
        //console.log("DATAFORRRRRM", data)
        this.setState({ dataForm: data })
      }).catch(function F(error) {
        console.log(error);
      });

      fetch(local + 'Validacion/Getapplaw', {
          method: 'GET'
      }).then(response => response.json())
          .then(data => {
              //console.log("leyesInicio", data.fecha_inicio_vice)
              //console.log("leyesFin", data.fecha_fin_vice)
              let banVice = currentDate > this.changeFormat(data.fecha_inicio_vice) && currentDate < this.changeFormat(data.fecha_fin_vice)
              this.setState({
                  bandera: banVice, checkCambioContrato: data.checkCambioContrato
              })
          }).catch(function F(error) {
              console.log(error);
          });

  }

  componentDidUpdate() {
      let user = this.context
      let ruta = window.location.pathname;
      if (user != null && this.state.idUser === 0) {
          this.setState({ idUser: user.idpersona, roles: user.roles });
          if (ruta.includes('/profesorVicerrector/')) {
            this.populateTable();
        }      
      /*console.log(user.roles);*/
    }

  }

  validateInput() {
    if (this.state.fila.length === this.state.validaciones.length) {
      /*console.log('validado')*/
      this.setState(() => ({
        next: true
      }))
    }
  }

  populateTable() {
      let resp = 0
      let notCurso = []
      let respuestas = []
      MySwal.fire({
          icon: 'warning',
          title: 'Por favor espere!',
          html: 'Estamos procesando la consulta, esto puede tomar hasta 1 minuto.',// add html attribute if you want or remove
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: false,
          onOpen: () => {
              Swal.showLoading()
          },
      })

      fetch(local + 'Vicerrector/GetObservacionesVicerrectorById/' + this.props.match.params.id, {
      method: 'GET'
    })
      .then(response => {
          resp = response.status
          MySwal.close();
        this.setState({ status: response.status });
        /*console.log(response.status);*/
        return response.json();
      })
      .then(data => {

        if (resp === 404 || resp === 400) {
          this.isNotFound();
        } else {
            data.validaciones.map(val => { respuestas.push(val.infoObservacion) })
            notCurso = data.validaciones.filter(x => x.cursoNull == 'S')
            //console.log("data", data);            
            this.setState({
                validaciones: data.validaciones, nombreProf: data.nombreProfesor, horasTotal: data.horasTotal,
                otrasHoras: data.otrasHoras, horasLicencia: data.horasLicencia,
                atendidoVice: data.atendidoVice,
                viceRespuestas: respuestas,
                tipoContrato: data.tipoContrato,
                enviado: data.enviado === "AD" || data.enviado === "DD" ? true : false,
                enviadoVRA: notCurso.length > 0 ? true : false,
                strDecisionDiretivo: data.strDecisionDiretivo
            })
            this.populateAUTH(data.idUnidad);            
        }
      })
      .catch(function F(error) {
        console.log(error);
      })
      
    }

    populateAUTH(unidad) {
        fetch(local + 'validacion/getdataUATH/' + unidad, {
            method: 'GET'
        }).then(response => response.json())
            .then(data => {
                /*console.log("DATAUATH", data)*/
                this.setState({ dataUATH: data })
            }).catch(function F(error) {
                console.log(error);
            });
    }

  isNotFound() {
    this.props.history.push({
      pathname: '/',
    })
    }

    changeFormat(fecha) {
        const date = fecha.split('T');
        //eXAMPLE
        //"2022-09-30"
        //"07:59:59"
        const [year, month, day] = date[0].split('-');
        const [hours, minutes, seconds] = date[1].split(':');

        var resp = new Date(+year, month - 1, +day, +hours, +minutes, +seconds);
        return resp;
    }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const key = target.id;
    //console.log(name);
    //console.log(target);
    //console.log(value);
    //console.log(key);
  }

  handleHideClick = (id) => {
    /*console.log(id)*/
    let obj = this.state.fila.find((o, i) => {
      if (o.id === id) {
        this.state.fila[i].validacion = 'si'
        return this.state.fila[i];
      }
      return null
    });
    if (obj === null) {
      this.state.fila.push({
        id: id,
        validacion: 'si'
      })
    }
    if (this.state.expanded.includes(id)) {
      this.setState(() => ({
        expanded: this.state.expanded.filter(x => x !== id)
      }));
    }
    /*console.log(this.state.fila);*/
    this.validateInput();
  }

  updateStatus = (idValid, estado, solic) => {
    //updating hours
    /*console.log('CAMBIO HORASSSSS', idValid)*/
    //console.log('not filter', this.state.delegados)
    //console.log('filter', this.state.delegados.filter(x => x.intIdValidacionDet !== idValid))
    let val = this.state.validaciones.find(x => x.intIdValidacionDet === idValid)
    if (val.delegado === "1") {
      this.setState(() => ({
        expanded: this.state.expanded.filter(x => x !== idValid),
        validaciones: this.state.validaciones.map(x => (x.intIdValidacionDet === idValid ? {
          ...x, solicitudForm: solic, estado: estado, delegado: "0"
        } : x)), delegados: this.state.delegados.filter(x => x.intIdValidacionDet !== idValid),          
      }));
    } else {
      this.setState(() => ({
        expanded: this.state.expanded.filter(x => x !== idValid),
        validaciones: this.state.validaciones.map(x => (x.intIdValidacionDet === idValid ? {
          ...x, solicitudForm: solic, estado: estado
        } : x)),
          revisados: this.state.validaciones.map(x => (x.intIdValidacionDet === idValid && x.respuestaDecano === "S" ? {
              ...x, solicitudForm: solic, estado: estado
          }:x))
      }));
    }


  }

  updateDelegado = (idValid) => {
    //console.log("ENTRO UPDATE DELEGAR")
    //console.log(idValid)
    const coordinador = this.state.coordinadores.find(x => {
      return x.intIdPersona.toString() + x.idPrograma.toString() === this.state.idCoordinador + this.state.idPrograma
    });
    let validacion = this.state.validaciones.find(x => x.intIdValidacionDet === idValid)
    validacion.infoDelegado = { estadoCoordinador: "P", nombreCoordinador: coordinador.strApellidos + ' ' + coordinador.strNombres, solicitudCoordinador: null }

    if (this.state.delegados.some(x => x.intIdValidacionDet === idValid)) {
      this.setState(() => ({
        validaciones: this.state.validaciones.map(x => (x.intIdValidacionDet === idValid ? {
          ...x, delegado: "1", estado: "P", solicitudForm: null,
          infoDelegado: { estadoCoordinador: "P", nombreCoordinador: coordinador.strApellidos + ' ' + coordinador.strNombres, solicitudCoordinador: null }
        } : x)),
        delegados: this.state.delegados.map(x => (x.intIdValidacionDet === idValid ?
          {
            ...x, infoDelegado: { estadoCoordinador: "P", nombreCoordinador: coordinador.strApellidos + ' ' + coordinador.strNombres, solicitudCoordinador: null }
          } : x))

      }), //console.log(this.state.validaciones)
      );
    } else {
      this.setState(() => ({
        validaciones: this.state.validaciones.map(x => (x.intIdValidacionDet === idValid ? {
          ...x, delegado: "1", estado: "P", solicitudForm: null,
          infoDelegado: { estadoCoordinador: "P", nombreCoordinador: coordinador.strApellidos + ' ' + coordinador.strNombres, solicitudCoordinador: null }
        } : x)),
        delegados: [...this.state.delegados, validacion]

      }), //console.log(this.state.validaciones)
      );
    }
  }


  toggle(tab) {
    if (this.state.activeTab !== tab) this.setState({ activeTab: tab });
  }

  handleShowClick = (id) => {
    const validacion = this.state.validaciones.find(x => {
      return x.intIdValidacionDet === id
    })
    
    if (!this.state.expanded.includes(id)) {
      this.setState(() => ({
        expanded: [...this.state.expanded, id]
      }));
    } else {
      this.setState(() => ({
        expanded: this.state.expanded.filter(x => x !== id)
      }));
    }    
  }

  handleCoordinadorChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    var coordinador = this.state.coordinadores.find(x => {
      return x.intIdPersona.toString() + x.idPrograma.toString() === value
    });

    this.setState({ idCoordinador: coordinador.intIdPersona.toString(), idPrograma: coordinador.idPrograma.toString() });
    /*console.log(this.state.fila);*/

  }

  rejectValidation = () => {
      if (this.state.idValid != '0') {
      this.setState({ rechazarState: 'L' });
      var currentTime = new Date();
      var year = currentTime.getFullYear()
      /*console.log(this.state.idValid)*/
      const idValidacion = this.state.idValid
      let solic = this.state.validaciones.find(x => {
        return x.intIdValidacionDet === parseInt(this.state.idValid)
      });
      if (solic != null) {
        solic = toPostRequest(solic);
          solic.aprobado = 0;
          solic.anio = year;
        solic['observacion'] = this.state.observacion
        const data = JSON.stringify(solic)
        fetch(local + 'Validacion/PostValidacion', {
          headers: {
            'Content-Type': 'application/json'
          },
          method: 'POST',
          body: data,
        }).then((response) => {
          //response.json()
          if (response.ok) {
            this.updateStatus(idValidacion, 'R', { fechaFin: '', fechaInicio: '', strObservacion: '', termino: '', nivel: '', idCargaUnidad: '', horasTotal: solic.totalHoras });
            MySwal.fire({
              icon: 'success',
              title: 'Solicitud rechazada',
              text: 'Observación guardada exitosamente!',
              confirmButtonText: 'Listo',
              timer: 5000
            })
            }
            //console.log(data)
          //console.log(response)
        });
      }
      this.setState({ rechazarState: 'N' });
      this.handleModal(false, '0')
    }
    //this.validateInput();

    //this.handleModal(false, '0')
  }

  handleEnviar = (event) => {
    event.preventDefault();
    const data = JSON.stringify({idProfesor: this.state.idProf, estado: this.state.checkContrato ? "EDC" : "ED", rol: "S"})
    fetch(local + 'Validacion/PostDecisionDirectivo', {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: data,
    }).then((response) => {
      //response.json()
      if (response.ok) {
        MySwal.fire({
          icon: 'success',
          title: 'Observaciones enviadas',
          text: 'Enviado exitosamente!',
          confirmButtonText: 'Listo',
          timer: 5000
        })
        this.setState({
          enviado: !this.state.enviado
        })
      }
      //console.log(response)
    });
  
    }

    handleEnviarCorrection = (event) => {
        event.preventDefault();
        const data = JSON.stringify({ idProfesor: this.state.idProf, estado: this.state.checkContrato ? "EDC" : "ED", rol: "S" })
        fetch(local + 'Validacion/PostDecisionDirectivoCorrection', {
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: data,
        }).then((response) => {
            //response.json()
            if (response.ok) {
                MySwal.fire({
                    icon: 'success',
                    title: 'Observaciones enviadas',
                    text: 'Enviado exitosamente!',
                    confirmButtonText: 'Listo',
                    timer: 5000
                })
                this.setState({
                    enviado: !this.state.enviado
                })
            }
            //console.log(response)
        });

    }

    handleAprobarAutoridad = (event) => {
        event.preventDefault();
        this.setState({ operando: true });
        const data = JSON.stringify({ idProfesor: this.state.idProf, estado: "A", rol: "V" })
        //console.log(data);
        fetch(local + 'Vicerrector/PostDecisionAutoridad', {
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: data,
        }).then(response => response.json())
      .then(data => {        
          //console.log(data);
          //console.log(data.mensajes);
          if (data.status == 200) {
              MySwal.fire({
                  icon: 'success',
                  title: 'Solicitudes Enviadas',
                  text: 'No comentarios que enviar!',
                  confirmButtonText: 'Listo',
                  timer: 5000
              })
              this.setState({
                  enviado: !this.state.enviado,                  
              })
          } else {
              let alert = [];
              data.mensajes.map(val => { alert.push(val.observacion) });
              let mensaje = alert.join(' ');
              MySwal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: mensaje,
                  confirmButtonText: 'salir'                  
              })              
              this.setState({
                  enviado: !this.state.enviado,
                  alertas: data.mensajes
              })
          }
          this.setState({ operando: false });
          //console.log(this.state.alertas);
      }).catch(function F(error) {
        console.log(error);
      });
        
    }

    handleRechazarAutoridad = (event) => {
        event.preventDefault();
        this.setState({operando2: true});
        const list = this.state.viceRespuestas.map(item => {
            return {
                intIdPlnDecisionSolAutoridad: item.intIdPlnDecisionSolAutoridad,
                intIdValDetalle: item.intIdValDetalle,
                intIdProfesor: item.intIdProfesor,
                idplnsolicitudcambiodetactividades: item.idplnsolicitudcambiodetactividades,
                estado: item.estado,
                rol: item.rol,
                observacion: item.observacion
            }
        });
        const data = JSON.stringify(list)
        //console.log(data);
        fetch(local + 'Vicerrector/PostValidacionVicerrector', {
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: data,
        }).then((response) => {
            //response.json()
            if (response.ok) {
                MySwal.fire({
                    icon: 'success',
                    title: 'Observaciones enviadas',
                    text: 'Enviado exitosamente!',
                    confirmButtonText: 'Listo',
                    timer: 5000
                })
                this.setState({
                    enviado: !this.state.enviado
                })
            } else {
                MySwal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Error',
                    confirmButtonText: 'salir',
                    timer: 5000
                })
            }
            this.setState({ operando2: false });
            //console.log(response)
        });
    }

  delegar = () => {
      if (this.state.idValid != '0') {
          this.setState({ delegarState: 'L' });
      /*console.log(this.state.idValid)*/
      let solic = { "idValDetalle": this.state.idValid, "idCoordinador": this.state.idCoordinador, "idProgramaSaacp": this.state.idPrograma }
      const data = JSON.stringify(solic)
      fetch(local + 'Delegacion/PostDelegacionIndividual', {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: data,
      }).then((response) => {
        //response.json()
        if (response.ok) {
          MySwal.fire({
            icon: 'success',
            title: 'Delegación asignada',
            text: 'Delegación guardada exitosamente!',
            confirmButtonText: 'Listo',
            timer: 5000
          })
          this.updateDelegado(this.state.idValid)
          this.handleModalReasignar(false, '0')
          this.setState({ delegarState: 'N' });
        }
        //console.log(response)
      });
    }
  }

  removeDelegacion = (idVal) => {
    this.setState({
      delegados: this.state.delegados.filter(x => x.intIdValidacionDet !== idVal)
    })
  }

  aprobar = (estado) => {
    if (this.state.idValid != '0') {
      const delegacion = this.state.delegados.find(x => x.intIdValidacionDet === parseInt(this.state.idValid))
      /*console.log("DELEGACIOOOOOON", delegacion)*/
      let solic = { "idSolicitudDet": delegacion.infoDelegado.solicitudCoordinador.idValidDet, "estado": estado, "observacion": this.state.observacion }
      const data = JSON.stringify(solic)
      /*console.log(data)*/
      fetch(local + 'Delegacion/PostDecision', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: data,
      }).then((response) => {
        if (response.ok) {
          /*console.log('alola')*/
          MySwal.fire({
            icon: 'success',
            title: 'Solicitud ingresada',
            text: 'Datos guardados exitosamente!',
            confirmButtonText: 'Listo',
            timer: 5000
          })
          if (estado === 'A') {
            this.removeDelegacion(parseInt(this.state.idValid))
            this.updateStatus(this.state.idValid, delegacion.infoDelegado.estadoCoordinador, delegacion.infoDelegado.solicitudCoordinador)
          } else {
            let val = this.state.validaciones.find(x => x.intIdValidacionDet === this.state.idValid)
            this.setState(() => ({
              expanded: this.state.expanded.filter(x => x !== this.state.idValid),
              delegados: this.state.delegados.map(x => (x.intIdValidacionDet === this.state.idValid ? {
                ...x, infoDelegado: {nombreCoordinador: x.infoDelegado.nombreCoordinador, estadoCoordinador: "P", solicitudCoordinador: null}
              } : x))
            }));
          }

          this.handleModalDelegar(false, '0', estado)
        } else {
          response.json().then(data => {
            /*console.log(data);*/
            MySwal.fire(
              'Error',
              data.lMensajesError[0],
              'error'
            )
          })
          this.handleModalDelegar(false, '0', estado)
        }
      });
    }
  }

  handleChangeModal(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({ observacion: value });
    /*console.log(this.state.observacion);*/
    }

    handleChangeObservacionesVice(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let name = target.name.split('-');
        let cod = name[1];
        let observaciones = this.state.viceRespuestas.filter(x => x.intIdValDetalle != cod);
        let nuevo = this.state.viceRespuestas.filter(x => x.intIdValDetalle == cod)[0];
        nuevo.observacion = value;
        nuevo.estado = value == '' ? 'A' + nuevo.rol : 'R' + nuevo.rol;
        observaciones.push(nuevo);
        let comentados = observaciones.filter(x => x.observacion != "");
        let bandera = comentados.length > 0;
        //console.log(cod);
        //console.log(value);
        //console.log(observaciones);
        //console.log(nuevo);
        this.setState({ decanoRespuestas: observaciones, hayComentarios: bandera });
        
    }

  handleModal = (status, idValid, banderaI) => {
    //console.log('entro metodo')
    //console.log(status);
    //console.log(banderaI)
    this.setState(() => ({
        show: status, idValid: idValid, observacion: '', infoDelegado: banderaI
    }));

  }

  //abrir o cerrar modal para delegar
  handleModalReasignar = (status, idValid) => {

    if (Object.keys(this.state.coordinadores).length === 0) {
      fetch(local + 'Validacion/GetCoordinadores', {
        method: 'GET'
      }).then(response => response.json())
        .then(data => {
          /*console.log('DATA COORDINADORES', data)*/
          this.setState({ coordinadores: data, showReasignar: status, idValid: idValid, idCoordinador: 0, idPrograma: 0 })
        }).catch(function F(error) {
          console.log(error);
        });
    } else {
      /*console.log('entro metodo')*/
      //console.log(status);
      //console.log(idValid)
      this.setState(() => ({
        showReasignar: status, idValid: idValid, idCoordinador: '0', idPrograma: '0'
      }));
    }
  }

  handleModalDelegar = (status, idValid, aprobacion) => {
    if (aprobacion === "A") {
      if (status) {
        this.setState(() => ({
          showDelegarA: status, idValid: idValid
        }));
      } else {
        this.setState(() => ({
          showDelegarA: status, idValid: idValid, observacion: ''
        }));
      }

    } else {
      if (status) {
        this.setState(() => ({
          showDelegarR: status, idValid: idValid
        }));
      } else {
        this.setState(() => ({
          showDelegarR: status, idValid: idValid, observacion: ''
        }));
      }

    }
  }

  handleOnExpand = (row, isExpand, rowIndex, e) => {
    if (isExpand) {
      this.setState(() => ({
        expanded: [...this.state.expanded, row.id]
      }));
    } else {
      this.setState(() => ({
        expanded: this.state.expanded.filter(x => x !== row.id)
      }));
    }

  }

  returnColor = (estado) => {
    return colorStatus[estado]
  }

  handleStateChange = (status) => {
    if (status.status === Sticky.STATUS_FIXED) {
      this.setState(() => ({
        sticky: true
      }));
    } else if (status.status === Sticky.STATUS_ORIGINAL) {
      this.setState(() => ({
        sticky: false
      }));
    }
    };

    render() {
        const { validaciones, delegados, revisados, decanoRespuestas, hayComentarios, alertas, bandera } = this.state;
        let viceMode = window.location.pathname.includes('/profesorVicerrector/');        
        //console.log(decanoRespuestas);
        //console.log(hayComentarios);
        //console.log(alertas);
    const expandRow = {
      renderer: (row, rowIndex) => (
        <div>
          {row.intIdCurso != "0" ?
                    <><FormularioMateriaVice idForm={row.intIdValidacionDet} idProf={this.state.idProf}
                        nombreProf={this.state.nombreProf} dataForm={this.state.dataForm}
                        profesor={row} method={this.updateStatus} viewDelegar={this.state.activeTab}
                        infoDelegado={row.delegado == 1 && row.infoDelegado != null && row.infoDelegado.estadoCoordinador !== 'P'}
                        handleModal={this.handleModalDelegar} roles={this.state.roles} banderaDecano={viceMode} />
                        {decanoRespuestas.filter(x => x.intIdValidacionDet === row.intIdValidacionDet) != null ?
                            <Row hidden={!(viceMode)}>
                                <Col md={12}>
                                    <FormGroup>
                                        <Label for="observacion">
                                            Recomendación del Vicerrector
                                        </Label>
                                        <Input
                                            id={"observacionDecano" + row.intIdValidacionDet}
                                            name={"observacionDecano-" + row.intIdValidacionDet}
                                            type="textarea"
                                            className='form-control'
                                            onChange={this.handleChangeObservacionesVice}
                                            defaultValue={decanoRespuestas.filter(x => x.intIdValDetalle === row.intIdValidacionDet).map(x => { return x.observacion })}
                                            readOnly={this.state.enviado}
                                            required
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            : <></>}
                    </>
                    : <>
                        {<FormularioActVice idForm={row.intIdValidacionDet} idProf={this.state.idProf}
                            nombreProf={this.state.nombreProf} dataForm={this.state.dataForm}
                            profesor={row} dataUATH={this.state.dataUATH} idUnidad={this.state.idUnidad}
                            infoDelegado={row.delegado == 1 && row.infoDelegado != null && row.infoDelegado.estadoCoordinador !== 'P'}
                            method={this.updateStatus} updateHoras={this.updateHoras} viewDelegar={this.state.activeTab}
                            handleModal={this.handleModalDelegar} roles={this.state.roles} banderaDecano={viceMode} />}
                        {decanoRespuestas.filter(x => x.intIdValidacionDet === row.intIdValidacionDet) != null ?
                            <Row hidden={!(viceMode)}>
                                <Col md={12}>
                                    <FormGroup>
                                        <Label for="observacion">
                                            Recomendación del Vicerrector
                                        </Label>
                                        <Input
                                            id={"observacionDecano" + row.intIdValidacionDet}
                                            name={"observacionDecano-" + row.intIdValidacionDet}
                                            type="textarea"
                                            className='form-control'
                                            onChange={this.handleChangeObservacionesVice}
                                            defaultValue={decanoRespuestas.filter(x => x.intIdValDetalle === row.intIdValidacionDet).map(x => { return x.observacion })}
                                            readOnly={this.state.enviado}
                                            required
                                        />
                                    </FormGroup>
                                </Col>                                
                            </Row>
                            : <></>}
                    </>
          }
        </div>
      ),
      expanded: this.state.expanded,
      onExpand: this.handleOnExpand,
      expandByColumnOnly: true
        };

        //const alert = [];
        //alertas.map(val => { alert.push(val.observacion) });
        //console.log(alert);

    const columnsMat = [{
      dataField: 'intIdValidacionDet',
      text: 'ID',
      hidden: true,
      formatter: (cellContent, row, rowIndex) => {
        return (
          <div>
            {rowIndex + 1} alola
            {row['intIdValidacionDet']}
          </div>
        )
      }
    }, {
      dataField: 'strTipo',
      text: 'Actividad',
      headerStyle: color_head_desc_mat('act'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
      formatter: (cellContent, row, rowIndex) => {
        return (
          <div>
            {row['strTipo'] === 'M|R' ? "IMPARTICIÓN DE CLASES EN CURSOS DE GRADO" : row['strCategoria'] === 'C' ? "IMPARTICIÓN DE CLASES EN CURSOS DE POSGRADO INVESTIGACIÓN Y DOCTORADO" : "IMPARTICIÓN DE CLASES EN CURSOS DE POSGRADO PROFESIONALIZANTE"}
          </div>
        )
      }
    }, {
      dataField: 'strDescripcion',
      text: 'Asignatura',
      headerStyle: color_head_desc_mat('asi'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
      formatter: (cellContent, row, rowIndex) => {
        return (
          <div>
            {row['strDescripcion']}
          </div>
        )
      }
    }, {
      dataField: 'strObservacion',
      text: 'Observación',
      hidden: this.state.enviado,
      headerStyle: color_head_desc_mat('ob'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
    }, {
      dataField: 'strPeriodo',
      text: 'Periodos',
      // hidden: this.state.enviado,
      headerStyle: color_head_desc_mat('per'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
    }, {
      dataField: 'paralelo',
      text: 'Par.',
      headerStyle: color_head_desc_mat('par'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
    }, {
      dataField: 'strAccion',
      text: 'Tipo Solicitud',
      headerStyle: color_head_desc_mat('tipo'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
    }, {
      text: 'Acciones',
      isDummyField: true,
      hidden: (this.state.enviado || !bandera),
      headerStyle: color_head_desc_mat('acc'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
      formatter: (cellContent, row, rowIndex) => {
        return (
          <>
            <div className='imgContainer'>
              {/* <button className="btn btn-success btn-circle btn-md" onClick={() => this.handleShowClick(row['intIdValidacionDet'])}></button>
            <button className="btn btn-danger btn-circle btn-md" onClick={() => this.handleModal(true, row['intIdValidacionDet'])}></button> */}
              {this.state.roles.includes('VICERRECTOR') && (viceMode) ? <BsEye size={30} alt="ver" onClick={() => this.handleShowClick(row['intIdValidacionDet'])} /> : <></>}              
            </div>              
          </>
        )
      }
    }, {
      text: 'Estado',
      isDummyField: true,
      datafield: 'vald',
      headerStyle: color_head_desc_mat('est'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
      formatter: (cellContent, row, rowIndex) => {
        return (
          <>
            <div className={'alola estado' + row['estado']} id={"estado" + row['intIdValidacionDet']}>
                <strong>{row['estado'] === 'A' ? "APROBADO" : row['estado'] === 'R' || row['estado'] === 'RA' ? "RECHAZADO" : "PENDIENTE"}</strong>
            </div>
            {row['delegado'] === '1' ? <>
              <hr style={{ marginTop: "20%" }} />
              <div className='lblDelegar' >
                <strong><u>DELEGADO</u></strong>
              </div>
            </>
              :
              <></>}
          </>

        )
      }
    }, {
      text: 'Horas',
      isDummyField: true,
      headerStyle: color_head_desc_mat('hor'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
      formatter: (cellContent, row, rowIndex) => {
        return (
          <>
            {row['solicitudForm'] ?
              (row['estado'] === 'A' && row['strAccion'] === 'Eliminar Carga') ?
                <div id={"horas" + row['intIdValidacionDet']} style={{ color: "red" }}><b>{row['solicitudForm']['horasTotal'] - row['totalHoras']}</b></div>
                :
                <>
                  0
                </>
              :
              <></>}

          </>

        )
      }
    }
    ];

    const columnsMatDec = [{
            dataField: 'intIdValidacionDet',
            text: 'ID',
            hidden: true,
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {rowIndex + 1} alola
                        {row['intIdValidacionDet']}
                    </div>
                )
            }
        }, {
            dataField: 'strTipo',
            text: 'Actividad',
            headerStyle: color_head_desc_mat('act'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {row['strTipo'] === 'M|R' ? "IMPARTICIÓN DE CLASES EN CURSOS DE GRADO" : row['strCategoria'] === 'C' ? "IMPARTICIÓN DE CLASES EN CURSOS DE POSGRADO INVESTIGACIÓN Y DOCTORADO" : "IMPARTICIÓN DE CLASES EN CURSOS DE POSGRADO PROFESIONALIZANTE"}
                    </div>
                )
            }
        }, {
            dataField: 'strDescripcion',
            text: 'Asignatura',
            headerStyle: color_head_desc_mat('asi'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {row['strDescripcion']}
                    </div>
                )
            }
        }, {
            dataField: 'strObservacion',
            text: 'Observación',
            hidden: this.state.enviado,
            headerStyle: color_head_desc_mat('ob'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
        }, {
            dataField: 'strPeriodo',
            text: 'Periodos',
            // hidden: this.state.enviado,
            headerStyle: color_head_desc_mat('per'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
        }, {
            dataField: 'paralelo',
            text: 'Par.',
            headerStyle: color_head_desc_mat('par'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
        }, {
            dataField: 'strAccion',
            text: 'Tipo Solicitud',
            headerStyle: color_head_desc_mat('tipo'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
        }, {
            text: 'Acciones',
            isDummyField: true,
            hidden: (!bandera),
            headerStyle: color_head_desc_mat('acc'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <>
                        <div className='imgContainer'>
                            {/* <button className="btn btn-success btn-circle btn-md" onClick={() => this.handleShowClick(row['intIdValidacionDet'])}></button>
            <button className="btn btn-danger btn-circle btn-md" onClick={() => this.handleModal(true, row['intIdValidacionDet'])}></button> */}
                            {this.state.roles.includes('VICERRECTOR') ? <BsEye size={30} alt="ver" onClick={() => this.handleShowClick(row['intIdValidacionDet'])} /> : <></>}
                        </div>                        
                    </>
                )
            }
        }, {
            text: 'Horas',
            isDummyField: true,
            headerStyle: color_head_desc_mat('hor'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <>
                        {row['solicitudForm'] ?
                            (row['estado'] === 'A' && row['strAccion'] === 'Eliminar Carga') ?
                                <div id={"horas" + row['intIdValidacionDet']} style={{ color: "red" }}><b>{row['solicitudForm']['horasTotal'] - row['totalHoras']}</b></div>
                                :
                                <>
                                    0
                                </>
                            :
                            <></>}

                    </>

                )
            }
        }
        ];

    const columnsMatResp = [{
            dataField: 'intIdValidacionDet',
            text: 'ID',
            hidden: true,
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {rowIndex + 1} alola
                        {row['intIdValidacionDet']}
                    </div>
                )
            }
        }, {
            dataField: 'strTipo',
            text: 'Actividad',
            headerStyle: color_head_desc_mat('act'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {row['strTipo'] === 'M|R' ? "IMPARTICIÓN DE CLASES EN CURSOS DE GRADO" : row['strCategoria'] === 'C' ? "IMPARTICIÓN DE CLASES EN CURSOS DE POSGRADO INVESTIGACIÓN Y DOCTORADO" : "IMPARTICIÓN DE CLASES EN CURSOS DE POSGRADO PROFESIONALIZANTE"}
                    </div>
                )
            }
        }, {
            dataField: 'strDescripcion',
            text: 'Asignatura',
            headerStyle: color_head_desc_mat('asi'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {row['strDescripcion']}
                    </div>
                )
            }
        }, {
            dataField: 'strObservacionDecano',
            text: 'Observación Decano',            
            headerStyle: color_head_desc_mat('ob'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
        }, {
            dataField: 'strPeriodo',
            text: 'Periodos',
            // hidden: this.state.enviado,
            headerStyle: color_head_desc_mat('per'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
        }, {
            dataField: 'paralelo',
            text: 'Par.',
            headerStyle: color_head_desc_mat('par'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
        }, {
            dataField: 'strAccion',
            text: 'Tipo Solicitud',
            headerStyle: color_head_desc_mat('tipo'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
        }, {
            text: 'Acciones',
            isDummyField: true,
            hidden: (!bandera),
            headerStyle: color_head_desc_mat('acc'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <>
                        <div className='imgContainer'>
                            {/* <button className="btn btn-success btn-circle btn-md" onClick={() => this.handleShowClick(row['intIdValidacionDet'])}></button>
            <button className="btn btn-danger btn-circle btn-md" onClick={() => this.handleModal(true, row['intIdValidacionDet'])}></button> */}
                            {this.state.roles.includes('VICERRECTOR') && (viceMode) ? <BsEye size={30} alt="ver" onClick={() => this.handleShowClick(row['intIdValidacionDet'])} /> : <></>}                            
                        </div>
                    </>
                )
            }
        }, {
            text: 'Horas',
            isDummyField: true,
            headerStyle: color_head_desc_mat('hor'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <>
                        {row['solicitudForm'] ?
                            (row['estado'] === 'A' && row['strAccion'] === 'Eliminar Carga') ?
                                <div id={"horas" + row['intIdValidacionDet']} style={{ color: "red" }}><b>{row['solicitudForm']['horasTotal'] - row['totalHoras']}</b></div>
                                :
                                <>
                                    0
                                </>
                            :
                            <></>}

                    </>

                )
            }
        }
        ];

    const columnsAct = [{
      dataField: 'intIdValidacionDet',
      text: 'ID',
      hidden: true,
      formatter: (cellContent, row, rowIndex) => {
        return (
          <div>
            {rowIndex + 1} alola
            {row['intIdValidacionDet']}
          </div>
        )
      }
    }, {
      dataField: 'strTipoActividad',
      text: 'Actividad',
      headerStyle: color_head_desc_act('tipo'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
      formatter: (cellContent, row, rowIndex) => {
        return (
          <div>
            {row['strTipoActividad']}
          </div>
        )
      }
    }, {
      dataField: 'strDescripcion',
      text: 'Descripción',
      headerStyle: color_head_desc_act('act'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
      formatter: (cellContent, row, rowIndex) => {
        return (
          <div>
            {row['strDescripcion']}
          </div>
        )
      }
    }, {
      dataField: 'strObservacion',
      text: 'Observación',
      headerStyle: color_head_desc_act('ob'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
    }, {
      dataField: 'strPeriodo',
      text: 'Periodos',
      hidden: this.state.enviado,
      headerStyle: color_head_desc_act('per'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
    }, {
      dataField: 'strAccion',
      text: 'Tipo Solicitud',
      headerStyle: color_head_desc_act('tipo'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
    }, {
      text: 'Acciones',
      isDummyField: true,
      hidden: this.state.enviado || !bandera,
      headerStyle: color_head_desc_act('acc'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
      formatter: (cellContent, row, rowIndex) => {
        return (
          <>
            <div className='imgContainer'>
              {/* <button className="btn btn-success btn-circle btn-md" onClick={() => this.handleShowClick(row['intIdValidacionDet'])}></button>
            <button className="btn btn-danger btn-circle btn-md" onClick={() => this.handleModal(true, row['intIdValidacionDet'])}></button> */}
              {this.state.roles.includes('VICERRECTOR') && (viceMode) ? <BsEye size={30} alt="ver" onClick={() => this.handleShowClick(row['intIdValidacionDet'])} /> : <></>}              
            </div>                
          </>
        )
      }
    }, {
      text: 'Estado',
      isDummyField: true,
      headerStyle: color_head_desc_act('est'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
      formatter: (cellContent, row, rowIndex) => {
        return (
          <>
            <div className={'alola estado' + row['estado']} id={"estado" + row['intIdValidacionDet']}>
              <strong>{row['estado'] === 'A' ? "APROBADO" : row['estado'] === 'R' ? "RECHAZADO" : "PENDIENTE"}</strong>
            </div>
            {row['delegado'] === '1' ? <>
              <hr style={{ marginTop: "20%" }} />
              <div className='lblDelegar' >
                <strong><u>DELEGADO</u></strong>
              </div>
            </>
              :
              <></>}

          </>


        )
      }
    }, {
      text: 'Horas',
      isDummyField: true,

      headerStyle: color_head_desc_act('hor'),
      style: (cell, row, rowIndex, colIndex) => {
        return color(rowIndex)
      },
      formatter: (cellContent, row, rowIndex) => {
        return (
          <>
            {row['solicitudForm'] ?
              row['estado'] === 'R' ?
                <>
                  0
                </>
                :
                row['solicitudForm']['horasTotal'] - row['totalHoras'] > 0 ?
                  <div id={"horas" + row['intIdValidacionDet']} style={{ color: "green" }}><b>{row['solicitudForm']['horasTotal'] - row['totalHoras']}</b></div> : row['solicitudForm']['horasTotal'] - row['totalHoras'] === 0 ?
                    <div id={"horas" + row['intIdValidacionDet']} ><b>{row['solicitudForm']['horasTotal'] - row['totalHoras']}</b></div> :
                    <div id={"horas" + row['intIdValidacionDet']} style={{ color: "red" }}><b>{row['solicitudForm']['horasTotal'] - row['totalHoras']}</b></div>
              :
              <></>}

          </>

        )
      }
    }
    ];

        const columnsActDec = [{
            dataField: 'intIdValidacionDet',
            text: 'ID',
            hidden: true,
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {rowIndex + 1} alola
                        {row['intIdValidacionDet']}
                    </div>
                )
            }
        }, {
            dataField: 'strTipoActividad',
            text: 'Actividad',
            headerStyle: color_head_desc_act('tipo'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {row['strTipoActividad']}
                    </div>
                )
            }
        }, {
            dataField: 'strDescripcion',
            text: 'Descripción',
            headerStyle: color_head_desc_act('act'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {row['strDescripcion']}
                    </div>
                )
            }
        }, {
            dataField: 'strObservacion',
            text: 'Observación',
            headerStyle: color_head_desc_act('ob'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
        }, {
            dataField: 'strPeriodo',
            text: 'Periodos',
            hidden: this.state.enviado,
            headerStyle: color_head_desc_act('per'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
        }, {
            dataField: 'strAccion',
            text: 'Tipo Solicitud',
            headerStyle: color_head_desc_act('tipo'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
        }, {
            text: 'Acciones',
            isDummyField: true,
            hidden: (!bandera),
            headerStyle: color_head_desc_act('acc'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <>
                        <div className='imgContainer'>
                            {/* <button className="btn btn-success btn-circle btn-md" onClick={() => this.handleShowClick(row['intIdValidacionDet'])}></button>
            <button className="btn btn-danger btn-circle btn-md" onClick={() => this.handleModal(true, row['intIdValidacionDet'])}></button> */}
                            {this.state.roles.includes('VICERRECTOR') && (viceMode) ? <BsEye size={30} alt="ver" onClick={() => this.handleShowClick(row['intIdValidacionDet'])} /> : <></>}                            
                        </div>                        
                    </>
                )
            }
        }, {
            text: 'Horas',
            isDummyField: true,

            headerStyle: color_head_desc_act('hor'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <>
                        {row['solicitudForm'] ?
                            row['estado'] === 'R' ?
                                <>
                                    0
                                </>
                                :
                                row['solicitudForm']['horasTotal'] - row['totalHoras'] > 0 ?
                                    <div id={"horas" + row['intIdValidacionDet']} style={{ color: "green" }}><b>{row['solicitudForm']['horasTotal'] - row['totalHoras']}</b></div> : row['solicitudForm']['horasTotal'] - row['totalHoras'] === 0 ?
                                    <div id={"horas" + row['intIdValidacionDet']} ><b>{row['solicitudForm']['horasTotal'] - row['totalHoras']}</b></div> :
                                    <div id={"horas" + row['intIdValidacionDet']} style={{ color: "red" }}><b>{row['solicitudForm']['horasTotal'] - row['totalHoras']}</b></div>
                            :
                            <></>}

                    </>

                )
            }
        }
        ];

        const columnsActResp = [{
            dataField: 'intIdValidacionDet',
            text: 'ID',
            hidden: true,
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {rowIndex + 1} alola
                        {row['intIdValidacionDet']}
                    </div>
                )
            }
        }, {
            dataField: 'strTipoActividad',
            text: 'Actividad',
            headerStyle: color_head_desc_act('tipo'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {row['strTipoActividad']}
                    </div>
                )
            }
        }, {
            dataField: 'strDescripcion',
            text: 'Descripción',
            headerStyle: color_head_desc_act('act'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {row['strDescripcion']}
                    </div>
                )
            }
        }, {
            dataField: 'strObservacionDecano',
            text: 'Observación Decano',
            headerStyle: color_head_desc_act('ob'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
        }, {
            dataField: 'strPeriodo',
            text: 'Periodos',
            hidden: this.state.enviado,
            headerStyle: color_head_desc_act('per'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
        }, {
            dataField: 'strAccion',
            text: 'Tipo Solicitud',
            headerStyle: color_head_desc_act('tipo'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
        }, {
            text: 'Acciones',
            isDummyField: true,
            hidden: (!bandera),
            headerStyle: color_head_desc_act('acc'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <>
                        <div className='imgContainer'>
                            {/* <button className="btn btn-success btn-circle btn-md" onClick={() => this.handleShowClick(row['intIdValidacionDet'])}></button>
            <button className="btn btn-danger btn-circle btn-md" onClick={() => this.handleModal(true, row['intIdValidacionDet'])}></button> */}
                            {this.state.roles.includes('VICERRECTOR') && (viceMode) ? <BsEye size={30} alt="ver" onClick={() => this.handleShowClick(row['intIdValidacionDet'])} /> : <></>}                            
                        </div>
                    </>
                )
            }
        }, {
            text: 'Horas',
            isDummyField: true,

            headerStyle: color_head_desc_act('hor'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <>
                        {row['solicitudForm'] ?
                            row['estado'] === 'R' ?
                                <>
                                    0
                                </>
                                :
                                row['solicitudForm']['horasTotal'] - row['totalHoras'] > 0 ?
                                <div id={"horas" + row['intIdValidacionDet']} style={{ color: "green" }}><b>{row['solicitudForm']['horasTotal'] - row['totalHoras']}</b></div> : row['solicitudForm']['horasTotal'] - row['totalHoras'] === 0 ?
                                <div id={"horas" + row['intIdValidacionDet']} ><b>{row['solicitudForm']['horasTotal'] - row['totalHoras']}</b></div> :
                                <div id={"horas" + row['intIdValidacionDet']} style={{ color: "red" }}><b>{row['solicitudForm']['horasTotal'] - row['totalHoras']}</b></div>
                            :
                            <></>}

                    </>

                )
            }
        }
        ];

    const elemModalEscogido = this.state.idValid !== "0" ? this.state.validaciones.find(x => {
      return x.intIdValidacionDet === parseInt(this.state.idValid)
    }) : null;

    const gradoAsi = validaciones.filter(x => x.strTipo === "M|R");
    const gradoAct = validaciones.filter(x => x.strTipo === "A|R");
    const posgradoAsi = validaciones.filter(x => x.strTipo === "M|P");
    const posgradoAct = validaciones.filter(x => x.strTipo === "A|P");
    const invAct = validaciones.filter(x => x.strTipo === "A|I");
    const vinAct = validaciones.filter(x => x.strTipo === "A|V");
    const gesAct = validaciones.filter(x => x.strTipo === "A|G");

    const objHour = rankHours[this.state.tipoContrato];

    let horasTPL = this.state.horasTotal + this.state.horasLicencia;

    let otrasHoras = this.state.otrasHoras;

        let horasRequeridas = validaciones.filter(x => x.solicitudForm && !((x.strTipo === "M|R" || x.strTipo === "M|P") && x.strAccion === "Modificar Carga")  && x.esProf !== "S").reduce(
          (acc, val) => val.solicitudForm.horasTotal - val.totalHoras + acc, 0
        )
    let horasModificadas = (horasTPL + horasRequeridas);

    let otrashorasRequeridas = validaciones.filter(x => x.solicitudForm && !((x.strTipo === "M|P") && x.strAccion === "Modificar Carga") && x.esProf == "S").reduce(
          (acc, val) => val.solicitudForm.horasTotal - val.totalHoras + acc, 0
      )
    let otrashorasModificadas = (this.state.otrasHoras + otrashorasRequeridas);

        //if (this.state.atendidoVice == "S") {

        //    horasRequeridas = validaciones.filter(x => x.solicitudForm && !((x.strTipo === "M|R" || x.strTipo === "M|P")
        //        && x.strAccion === "Modificar Carga") && x.esProf !== "S"
        //        && (x.strObservacionVicerrector == "Aprobado Por Vicerrectorado")).reduce(
        //            (acc, val) => val.solicitudForm.horasTotal - val.totalHoras + acc, 0
        //        )
        //    horasModificadas = (horasTPL);

        //    horasTPL = horasModificadas - horasRequeridas;

        //    otrashorasRequeridas = validaciones.filter(x => x.solicitudForm && !((x.strTipo === "M|P")
        //        && x.strAccion === "Modificar Carga") && x.esProf == "S" && (x.strObservacionVicerrector == "Aprobado Por Vicerrectorado")).reduce(
        //                (acc, val) => val.solicitudForm.horasTotal - val.totalHoras + acc, 0
        //            )
        //    otrashorasModificadas = (this.state.otrasHoras);

        //    otrasHoras = otrashorasModificadas - otrashorasRequeridas;
        //}

        //console.log("Horas", horasTPL);
        //console.log("difercncia", horasRequeridas);
        //console.log("total", horasModificadas);
        //console.log("Otras Horas", otrasHoras);
        //console.log("dif otrass", otrashorasRequeridas);
        //console.log("otras total", otrashorasModificadas);

    return (
      <>
        <br />
            {this.state.roles.includes('VICERRECTOR')
          ?
          <Sticky innerZ={1001} top={0} onStateChange={() => this.handleStateChange}>
              <div className={'infoHoras'}>
              <Row style={{ paddingTop: "0.75%" }}>
                 <Col sm="4" >
                    <div className='labelProf'><b>
                         {this.state.nombreProf.split('/')[1]}</b>
                    </div>
                 </Col>
              </Row>
              <Row style={{ paddingTop: "0.75%" }}>                
                <Col sm="4">
                  <b> DEDICACION: </b>

                  {objHour ? objHour.label : ""}

                </Col>
                <Col sm="4">
                  <b>RANGO DE HORAS: </b>

                  MIN: {objHour ? parseInt(objHour.min).toLocaleString('en', { maximumFractionDigits: 2 }) : ""}H - MAX: {objHour ? parseInt(objHour.max).toLocaleString('en', { maximumFractionDigits: 2 }) : ""}H

                </Col>
                <Col sm="4" >
                 <b>HORAS DE LICENCIAS: &emsp;</b>
                 <b>{this.state.horasLicencia.toLocaleString('en', { maximumFractionDigits: 2 })}</b>
                </Col>
              </Row>
              <hr />
              <Row >
                 {objHour ?
                 <Col sm="4" style={{ color: objHour.min <= horasTPL && objHour.max >= horasTPL ? "green" : "red" }}>
                    TOTAL HORAS PLANIFICADAS + LICENCIAS:&emsp;<strong>{horasTPL.toLocaleString('en', { maximumFractionDigits: 2 })}</strong>
                  </Col>
                  : ""}
                <Col sm="4">
                  DIFERENCIAL HORA:&emsp;<strong>{horasRequeridas.toLocaleString('en', { maximumFractionDigits: 2 })}</strong>
                </Col>
                {objHour && horasRequeridas !== 0 ?
                  <Col sm="4" style={{ color: objHour.min <= horasModificadas && objHour.max >= horasModificadas ? "green" : "red" }}>
                    TOTAL HORAS MODIFICADAS: &emsp;<strong>{horasModificadas.toLocaleString('en', { maximumFractionDigits: 2 })}</strong>
                  </Col>
                  : ""
                }
              </Row>
              <hr />
              <Row style={{ paddingBottom: "0.75%" }}>
                {objHour ?
                  <Col sm="4">
                    HORAS DE ACTIVIDADES INDEPENDIENTES REMUNERADAS:&emsp;<strong>{otrasHoras.toLocaleString('en', { maximumFractionDigits: 2 })}</strong>
                  </Col>
                  : ""}
                <Col sm="4">
                    DIFERENCIAL HORA:&emsp;<strong>{otrashorasRequeridas.toLocaleString('en', { maximumFractionDigits: 2 })}</strong>
                </Col>
                {objHour && horasRequeridas !== 0 ?
                  <Col sm="4" >
                  TOTAL OTRAS HORAS: &emsp;<strong>{otrashorasModificadas.toLocaleString('en', { maximumFractionDigits: 2 })}</strong>
                  </Col>
                  : ""
                }
              </Row>
            </div>
          </Sticky> : <></>}
            <br />            

            {this.state.roles.includes('SUBDECANO') && this.state.enviado && !(viceMode)
          ?
          <UncontrolledAlert color="warning">
             <h6 style={{ paddingLeft: "20px" }}>  <img src={images['notificacion.svg'].default} alt="alert" style={{ width: "20px", height: "20px" }} /> INFORMACIÓN</h6>
             <div style={{ textAlign: 'center' }}>Las observaciones del presente profesor no pueden editarse pues ya se envio al Decano.</div>
          </UncontrolledAlert> : <></>}
        <Nav tabs id="obDel">
          <NavItem>
            <NavLink className={classnames({ active: this.state.activeTab === '1' })} onClick={() => this.toggle('1')}>
              Observaciones
            </NavLink>
                </NavItem>                
                
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            {(gradoAsi.length > 0 || gradoAct.length > 0) ? <h3 className='header grado'>DOCENCIA GRADO</h3> : <></>}
            {gradoAsi.length > 0 ? <>
              <BootstrapTable
                id="materiaGrado"
                keyField="intIdValidacionDet"
                data={gradoAsi}
                columns={columnsMatDec}
                expandRow={expandRow}
              /> <br /></>
              : <></>}
            {gradoAct.length > 0 ? <>
              <BootstrapTable
                id="actGrado"
                keyField="intIdValidacionDet"
                data={gradoAct}
                columns={columnsActDec}
                expandRow={expandRow}
              /> <br /></>
              : <></>}
            {(posgradoAsi.length > 0 || posgradoAct.length > 0) ? <h3 className='header posgrado'>DOCENCIA POSGRADO</h3> : <></>}
            {posgradoAsi.length > 0 ? <>
              <BootstrapTable
                id="materiaPosgrado"
                keyField="intIdValidacionDet"
                data={posgradoAsi}
                columns={columnsMatDec}
                expandRow={expandRow}
              /> <br /></>
              : <></>}
            {posgradoAct.length > 0 ? <>
              <BootstrapTable
                id="actPosgrado"
                keyField="intIdValidacionDet"
                data={posgradoAct}
                columns={columnsActDec}
                expandRow={expandRow}
              /> <br /></>
              : <></>}
            {invAct.length > 0 ? <>
              <h3 className='header inv'>INVESTIGACIÓN</h3>
              <BootstrapTable
                id="investigacion"
                keyField="intIdValidacionDet"
                data={invAct}
                columns={columnsActDec}
                expandRow={expandRow}
              /> <br /></>
              : <></>}
            {gesAct.length > 0 ? <>
              <h3 className='header gestion'>GESTIÓN ACADÉMICA</h3>
              <BootstrapTable
                id="gestion"
                keyField="intIdValidacionDet"
                data={gesAct}
                columns={columnsActDec}
                expandRow={expandRow}
              /> <br /></>
              : <></>}
            {vinAct.length > 0 ? <>
              <h3 className='header vinculo'>VINCULACIÓN</h3>
              <BootstrapTable
                id="vinculos"
                keyField="intIdValidacionDet"
                data={vinAct}
                columns={columnsActDec}
                expandRow={expandRow}
              /> <br /></>
              : <></>}
            {validaciones.filter(x => x.delegado === "0").length === this.state.validaciones.length &&
              validaciones.every(x => x.solicitudForm !== null) && objHour && validaciones.some(x => x.estado === "A") && !this.state.enviado ?
              <Form onSubmit={this.handleEnviar} id='enviarForm'>
                <Row>
                  <Col sm="2">
                    <Button type="submit" className='btn-success btn-round' disabled={!this.state.checkContrato && !(objHour.min <= horasModificadas)}>
                      Enviar a Decano
                    </Button>
                  </Col>
                  {!(objHour.min <= horasModificadas) ?
                    <Col sm="10">
                      <label>
                        <input
                          type="checkbox"
                          name="contrato"
                          onChange={() => this.setState({ checkContrato: !this.state.checkContrato })}
                          checked={this.state.checkContrato}
                        />
                        &nbsp;Este profesor no cumple con el rango de horas de dedicación de su contrato, si usted esta seguro de que va a tener un cambio de contrato,
                        cliquee para habilitar el botón enviar, caso contrario complete el tiempo de dedicación requerido.
                      </label> </Col> : <></>}

                </Row>
              </Form>
              : <></>
              }                    
                    {
                        viceMode && validaciones.length > 0 && !(this.state.enviado) && bandera ?
                            <Row>
                                <Col sm="8"></Col>
                                <Col sm="2">
                                    <Button className='btn-warning btn-round' disabled={!hayComentarios || this.state.operando || this.state.operando2} onClick={this.handleRechazarAutoridad} >
                                        {this.state.operando2 ? <Spinner animation="grow" size='sm' /> : 'Rechazar Solicitud'}
                                    </Button>
                                </Col>
                                <Col sm="2">
                                    <Button className='btn-info btn-round' hidden={this.state.enviadoVRA} disabled={hayComentarios || this.state.operando || this.state.operando2} onClick={this.handleAprobarAutoridad} >
                                        {this.state.operando ? <Spinner animation="grow" size='sm' /> : 'Aprobar Solicitud'}
                                    </Button>
                                </Col>
                            </Row>
                            : <></>
                    }
            <br ></br>
            <Modal show={this.state.show} onHide={() => this.handleModal(false, '0')}>
              <Modal.Header closeButton>
                <Modal.Title>Rechazar observación</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Escriba el motivo por el cual rechaza la observación
              <Input type="textarea" id="textAreaModal" maxLength="300" onChange={this.handleChangeModal} defaultValue={this.state.observacion} required />
              </Modal.Body>
              <Modal.Footer>
                <button className='btn btn-secondary' disabled={this.state.rechazarState === 'L' ? 'disabled' : ''} onClick={() => this.handleModal(false, '0')}>
                  Cancelar
                </button>
                <button type="button" disabled={this.state.rechazarState === 'L' || this.state.infoDelegado ? 'disabled' : ''} className='btn btn-primary' onClick={() => this.rejectValidation()}>
                   {this.state.infoDelegado ? 'Revisar delegación' : 'Enviar'} {this.state.rechazarState === 'L' ? <Spinner animation="grow" size='sm' /> : ''}
                </button>
              </Modal.Footer>
            </Modal>            

          </TabPane>                    
            </TabContent>
      </>
    );
  }
}
ExpandTable.contextType = AppContext;
export default withRouter(ExpandTable);